import {stringifyParams} from '../../../../../modules/apis/ApiFetcher4';

const fetchLangstonSuggestions = async(text = '') => {
  const resource = '/api/v3/content/delivery/suggestions/';

  const queryString = stringifyParams({
    needle: text,
    limit: 5,
  });

  try {
    const response = await fetch(`${resource}${queryString}`, {
      method: 'GET',
      credentials: 'include',
    });
    return await response?.json();
  } catch (error) {
    return error;
  }
};

const fetchSuggestionsService = async(text = '') => {
  const resource = '/agatha/api/suggestions/';

  const queryString = stringifyParams({
    fragment: text,
    page_size: 5,
    segmented_trending: true,
    strategy: 'ranked',
  });

  try {
    const response = await fetch(`${resource}${queryString}`);
    return await response?.json();
  } catch (error) {
    return error;
  }
};

export {fetchSuggestionsService, fetchLangstonSuggestions};
